import { useEffect, useState } from "react";

export default function CookieBanner({ onAccept }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");

    if (!consent) {
      setShow(true);
    } else if (consent === "accepted") {
      onAccept?.();
    }
  }, [onAccept]);

  const accept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShow(false);
    onAccept?.();
  };

  const reject = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div style={styles.banner}>
      <div style={styles.text}>
        Flightle uses optional analytics cookies to help improve the game.
        You can accept or reject these cookies.
        <br />
<a href="/privacy.html">
  Privacy Policy
</a>
      </div>

      <div style={styles.buttons}>
        <button style={styles.reject} onClick={reject}>
          Reject
        </button>

        <button style={styles.accept} onClick={accept}>
          Accept
        </button>
      </div>
    </div>
  );
}

const styles = {
  banner: {
    position: "fixed",
    left: 20,
    right: 20,
    bottom: 20,
    background: "white",
    borderRadius: 18,
    padding: 18,
    boxShadow: "0 10px 35px rgba(0,0,0,0.18)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 20,
    zIndex: 9999,
    maxWidth: 850,
    margin: "auto"
  },

  text: {
    fontSize: 14,
    lineHeight: 1.4,
    flex: 1
  },

  buttons: {
    display: "flex",
    gap: 10
  },

  accept: {
    background: "#6ca965",
    color: "white",
    border: "none",
    borderRadius: 10,
    padding: "10px 18px",
    cursor: "pointer"
  },

  reject: {
    background: "#eee",
    border: "none",
    borderRadius: 10,
    padding: "10px 18px",
    cursor: "pointer"
  }
  
};